import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
}

export default function MyAttendance() {
  const [records, setRecords] = useState([]);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/me/attendance", { params: { month } }); setRecords(data); } catch {}
    })();
  }, [month]);

  return (
    <div className="space-y-6" data-testid="me-attendance">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <div className="font-mono text-[10px] tracking-widest uppercase text-zinc-500 mb-2">My space</div>
          <h1 className="font-heading text-4xl font-black tracking-tight">Attendance</h1>
          <p className="text-sm text-zinc-500 mt-1">Your check-in / check-out history.</p>
        </div>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="font-mono text-sm border border-zinc-300 px-3 py-1.5 rounded-sm" />
      </div>
      <div className="bg-white border border-zinc-200 rounded-sm">
        <Table>
          <TableHeader>
            <TableRow className="bg-zinc-50 hover:bg-zinc-50">
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Date</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Check-in</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Check-out</TableHead>
              <TableHead className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {records.length === 0 && (
              <TableRow><TableCell colSpan={4} className="text-center py-12 text-sm text-zinc-500">No records this month.</TableCell></TableRow>
            )}
            {records.map((r) => (
              <TableRow key={r.id} className="hover:bg-zinc-50">
                <TableCell className="font-mono text-sm">{r.date}</TableCell>
                <TableCell className="font-mono text-sm">{fmtTime(r.check_in)}</TableCell>
                <TableCell className="font-mono text-sm">{fmtTime(r.check_out)}</TableCell>
                <TableCell><span className="font-mono text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm bg-emerald-100 text-emerald-700">{r.status}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
